import api from '../../services/apiService'

const companies = "/init/companies";

const getCompanies = () => api.framework.get(companies).then(res => res);

export { getCompanies };